










































































































































































































import Vue, { PropType } from "vue";
import { AxiosResponse } from "axios";
import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
// components
import SelectedFiltersChip from "@/features/analytics/components/SelectedFiltersChip.vue";
// api
import { getAdunits } from "@/commons/axios/adunit";
import { getPublishers } from "@/commons/axios/publisher";
import * as reportApi from "@/features/analytics/axios";
// types
import { PublishersAdunitResponse, PublishersResponse } from "@/commons/types";
import {
  FiltersInput,
  Publisher,
  Bidder,
  Adunit,
  AdunitGroup,
  Domain,
  GetBiddersResponse,
  GetAdunitGroupsResponse,
  GetDomainsResponse,
} from "@/features/analytics/types";
// utils
import * as notifyUtil from "@/commons/utils/notifyUtil";
import { getTotalPage } from "@/commons/utils/getTotalPage";
import asyncSleep from "@/commons/utils/asyncSleep";
// Enum
import { Enum } from "@/commons/enums/Type";
import { FilterEnum } from "@/features/analytics/enums/Filter";
import { ReportTypeEnum } from "@/features/analytics/enums/ReportType";
import { DeviceEnum } from "@/features/analytics/enums/Device";
import { BrowserEnum } from "@/features/analytics/enums/Browser";
import { OsEnum } from "@/features/analytics/enums/Os";

extend("emojiSyntax", {
  validate(value) {
    const emojiRegex = new RegExp(require("emoji-regex"));
    return !emojiRegex.test(value);
  },
});

export default Vue.extend({
  components: {
    "selected-filterschip": SelectedFiltersChip,
    "validation-observer": ValidationObserver,
    "validation-provider": ValidationProvider,
  },

  props: {
    title: { type: String, required: true },
    reportTypeInput: { type: Number, required: true },
    filtersInput: {
      type: Array as PropType<FiltersInput[]>,
      required: true,
    },
  },

  data() {
    return {
      loading: false as boolean,
      pageIndex: 1 as number,
      publisherList: [] as Publisher[],
      selectionPublisherList: [] as Publisher[],
      bidderList: [] as Bidder[],
      adunitList: [] as Adunit[],
      adunitGroupList: [] as AdunitGroup[],
      domainList: [] as Domain[],
      activeFilter: 0 as number,
      searchName: "" as string,
      selectedPublisherId: 0 as number,
      filterSize: 0 as number,
    };
  },

  computed: {
    isMobileDisplay(): boolean {
      const me = this as any;
      return me.$vuetify.breakpoint.name === "xs" || me.$vuetify.breakpoint.name === "sm";
    },
    isPublisherFilter(): boolean {
      const me = this as any;
      return me.activeFilter === FilterEnum.PUBLISHER.value;
    },
    childBiddersInput(): any[] {
      const tmpArray = [] as any[];
      (this as any).filtersInput.forEach((item: FiltersInput) => {
        if (item.filterType === FilterEnum.BIDDER.value) {
          tmpArray.push({
            text: item.conditionName,
            value: item.conditionId,
          });
        }
      });
      return tmpArray;
    },
    childAdunitsInput(): any[] {
      const tmpArray = [] as any[];
      (this as any).filtersInput.forEach((item: FiltersInput) => {
        if (item.filterType === FilterEnum.ADUNIT.value) {
          tmpArray.push({
            text: item.conditionName,
            value: item.conditionId,
          });
        }
      });
      return tmpArray;
    },
    childAdunitGroupsInput(): any[] {
      const tmpArray = [] as any[];
      (this as any).filtersInput.forEach((item: FiltersInput) => {
        if (item.filterType === FilterEnum.ADUNIT_GROUP.value) {
          tmpArray.push({
            text: item.conditionName,
            value: item.conditionId,
          });
        }
      });
      return tmpArray;
    },
    childDevicesInput(): any[] {
      const tmpArray = [] as any[];
      (this as any).filtersInput.forEach((item: FiltersInput) => {
        if (item.filterType === FilterEnum.DEVICE.value) {
          tmpArray.push({
            text: item.conditionName,
            value: item.conditionId,
          });
        }
      });
      return tmpArray;
    },
    childBrowsersInput(): any[] {
      const tmpArray = [] as any[];
      (this as any).filtersInput.forEach((item: FiltersInput) => {
        if (item.filterType === FilterEnum.BROWSER.value) {
          tmpArray.push({
            text: item.conditionName,
            value: item.conditionId,
          });
        }
      });
      return tmpArray;
    },
    childOsInput(): any[] {
      const tmpArray = [] as any[];
      (this as any).filtersInput.forEach((item: FiltersInput) => {
        if (item.filterType === FilterEnum.OS.value) {
          tmpArray.push({
            text: item.conditionName,
            value: item.conditionId,
          });
        }
      });
      return tmpArray;
    },
    childDomainsInput(): any[] {
      const tmpArray = [] as any[];
      (this as any).filtersInput.forEach((item: FiltersInput) => {
        if (item.filterType === FilterEnum.DOMAIN.value) {
          tmpArray.push({
            text: item.conditionName,
            value: item.conditionId,
          });
        }
      });
      return tmpArray;
    },
    childPublishersInput(): any[] {
      const tmpArray = [] as any[];
      (this as any).filtersInput.forEach((item: FiltersInput) => {
        if (item.filterType === FilterEnum.PUBLISHER.value) {
          tmpArray.push({
            text: item.conditionName,
            value: item.conditionId,
          });
        }
      });
      return tmpArray;
    },
    filters(): Enum[] {
      // Prebid Analytics が選択された時
      if (this.reportTypeInput === ReportTypeEnum.PREBID_ANALYTICS.value) {
        return [
          { value: FilterEnum.BIDDER.value, text: FilterEnum.BIDDER.jaText },
          { value: FilterEnum.ADUNIT.value, text: FilterEnum.ADUNIT.jaText },
          { value: FilterEnum.DEVICE.value, text: FilterEnum.DEVICE.jaText },
          { value: FilterEnum.BROWSER.value, text: FilterEnum.BROWSER.jaText },
          { value: FilterEnum.OS.value, text: FilterEnum.OS.jaText },
          { value: FilterEnum.DOMAIN.value, text: FilterEnum.DOMAIN.jaText },
          { value: FilterEnum.PUBLISHER.value, text: FilterEnum.PUBLISHER.jaText },
        ];
      }
      // BI Report が選択された時
      else if (this.reportTypeInput === ReportTypeEnum.BI_REPORT.value) {
        return [
          { value: FilterEnum.BIDDER.value, text: FilterEnum.BIDDER.jaText },
          { value: FilterEnum.ADUNIT.value, text: FilterEnum.ADUNIT.jaText },
          { value: FilterEnum.ADUNIT_GROUP.value, text: FilterEnum.ADUNIT_GROUP.jaText },
          { value: FilterEnum.DOMAIN.value, text: FilterEnum.DOMAIN.jaText },
          { value: FilterEnum.PUBLISHER.value, text: FilterEnum.PUBLISHER.jaText },
        ];
      }
      // Google Ad Manager が選択された時
      else if (this.reportTypeInput === ReportTypeEnum.GOOGLE_AD_MANAGER.value) {
        return [
          { value: FilterEnum.ADUNIT.value, text: FilterEnum.ADUNIT.jaText },
          { value: FilterEnum.DOMAIN.value, text: FilterEnum.DOMAIN.jaText },
          { value: FilterEnum.PUBLISHER.value, text: FilterEnum.PUBLISHER.jaText },
        ];
      }
      return [];
    },
    activeFilterList(): any[] {
      const me = this as any;
      let tmpArray = [] as any[];
      switch (this.activeFilter) {
        case FilterEnum.BIDDER.value:
          me.bidderList.forEach((item: any) => {
            // NOTE: vendorにreportTypeを持っていないため、フロントでPrebidの時のみAmazonを除外する
            if (
              me.reportTypeInput === ReportTypeEnum.PREBID_ANALYTICS.value &&
              item.vendorName === "Amazon"
            )
              return;
            tmpArray.push({
              text: item.vendorName,
              value: String(item.vendorId),
            });
          });
          break;
        case FilterEnum.ADUNIT.value:
          me.adunitList.forEach((item: Adunit) => {
            tmpArray.push({
              text: item.adunitName,
              value: String(item.adunitId),
            });
          });
          break;
        case FilterEnum.ADUNIT_GROUP.value:
          me.adunitGroupList.forEach((item: AdunitGroup) => {
            tmpArray.push({
              text: item.adunitGroupName,
              value: String(item.adunitGroupId),
            });
          });
          break;
        case FilterEnum.DEVICE.value:
          DeviceEnum.getList().forEach((item: Enum) => {
            tmpArray.push({
              text: item.text,
              value: String(item.value),
            });
          });
          break;
        case FilterEnum.BROWSER.value:
          BrowserEnum.getList().forEach((item: Enum) => {
            tmpArray.push({
              text: item.text,
              value: String(item.value),
            });
          });
          break;
        case FilterEnum.OS.value:
          OsEnum.getList().forEach((item: Enum) => {
            tmpArray.push({
              text: item.text,
              value: String(item.value),
            });
          });
          break;
        case FilterEnum.DOMAIN.value:
          me.domainList.forEach((item: Domain) => {
            tmpArray.push({
              text: item.domainName,
              value: String(item.domainId),
            });
          });
          break;
        case FilterEnum.PUBLISHER.value:
          me.selectionPublisherList.forEach((item: Publisher) => {
            tmpArray.push({
              text: item.publisherName,
              value: String(item.publisherId),
            });
          });
          break;
        default:
          break;
      }
      return tmpArray;
    },
    activeFiltersInput: {
      get() {
        const me = this as any;
        switch (me.activeFilter) {
          case FilterEnum.BIDDER.value:
            return me.childBiddersInput;
          case FilterEnum.ADUNIT.value:
            return me.childAdunitsInput;
          case FilterEnum.ADUNIT_GROUP.value:
            return me.childAdunitGroupsInput;
          case FilterEnum.DEVICE.value:
            return me.childDevicesInput;
          case FilterEnum.BROWSER.value:
            return me.childBrowsersInput;
          case FilterEnum.OS.value:
            return me.childOsInput;
          case FilterEnum.DOMAIN.value:
            return me.childDomainsInput;
          case FilterEnum.PUBLISHER.value:
            return me.childPublishersInput;
          default:
            return [];
        }
      },
      set(val: any) {
        let newValues = [] as any[];
        val.forEach((item: Enum) => {
          newValues.push({
            conditionId: String(item.value),
            conditionName: item.text,
            filterType: (this as any).activeFilter,
          });
        });
        return this.$emit("updateFilter", {
          newValue: newValues,
          filterType: (this as any).activeFilter,
        });
      },
    },
    isPublisherRelation(): boolean {
      return (
        this.activeFilter === FilterEnum.BIDDER.value ||
        this.activeFilter === FilterEnum.ADUNIT.value ||
        this.activeFilter === FilterEnum.ADUNIT_GROUP.value ||
        this.activeFilter === FilterEnum.DOMAIN.value ||
        this.activeFilter === FilterEnum.PUBLISHER.value
      );
    },
    isEmptyOfFilters(): boolean {
      return (this as any).filtersInput.length === 0;
    },
    totalPage(): number {
      const me = this as any;
      let total = 0 as number;

      if (me.isPublisherRelation && me.activeFilterList.length <= 100) {
        total = getTotalPage(me.filterSize);
      } else {
        total = getTotalPage(me.activeFilterList.length);
      }

      if (total === 0) {
        return 1;
      } else {
        return total;
      }
    },
    disabledPagenation(): boolean {
      const me = this as any;
      if (me.isPublisherFilter) return me.loading || me.activeFilterList.length === 0;
      else return me.loading || !me.selectedPublisherId || me.activeFilterList.length === 0;
    },
  },

  created() {
    const me = this as any;
    if (me.isMobileDisplay) {
      me.getPublishers();
    }
  },

  methods: {
    doSearchByName() {
      (this as any).pageIndex = 1;
      (this as any).doSearch();
    },
    doSearch() {
      const me = this as any;
      me.$refs.form.validate().then(async (success: boolean) => {
        if (!success) return;
        if (!me.selectedPublisherId && !me.isPublisherFilter) {
          notifyUtil.notifyErrorMessage(me.$t("analytics.text.selectPublisher"));
          return;
        }

        switch (me.activeFilter) {
          case FilterEnum.BIDDER.value:
            me.getBidders();
            break;
          case FilterEnum.ADUNIT.value:
            me.getAdunits();
            break;
          case FilterEnum.ADUNIT_GROUP.value:
            me.getAdunitGroups();
            break;
          case FilterEnum.DOMAIN.value:
            me.getDomains();
            break;
          case FilterEnum.PUBLISHER.value:
            me.filteringPublishers();
            break;
          case FilterEnum.DEVICE.value:
          case FilterEnum.BROWSER.value:
          case FilterEnum.OS.value:
          default:
            break;
        }
      });
    },
    getPublishers() {
      const me = this as any;
      me.loading = true;
      getPublishers()
        .then((res: AxiosResponse<PublishersResponse>) => {
          // レポートタイプが GAM の時は GAM 未対応パブリッシャーを弾く
          if (me.reportTypeInput === ReportTypeEnum.GOOGLE_AD_MANAGER.value) {
            me.publisherList = res.data.publishers.filter(
              publisher => publisher.report_type_available.gam !== null
            );
            me.selectionPublisherList = me.publisherList;
          }
          // GAM以外
          else {
            me.publisherList = res.data.publishers;
            me.selectionPublisherList = me.publisherList;
          }
          me.filteringPublishers();
        })
        .catch(error => {
          if (error.response.status === 401) {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
            this.$router.push({ name: "Login" });
          } else notifyUtil.notifyErrorMessage(me.$t("general.notify.error.request.publishers"));
        })
        .finally(() => {
          me.loading = false;
        });
    },
    getBidders() {
      const me = this as any;
      me.loading = true;
      reportApi
        .getBidders({
          publisherId: me.selectedPublisherId as number,
          page: me.pageIndex as number,
          name: me.searchName as string,
        })
        .then((res: AxiosResponse<GetBiddersResponse>) => {
          me.bidderList = res.data.vendors;
          me.filterSize = res.data.total;
        })
        .catch(error => {
          if (error.response.status === 401) {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
            this.$router.push({ name: "Login" });
          } else notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.bidders"));
        })
        .finally(() => {
          me.loading = false;
        });
    },
    getAdunits() {
      const me = this as any;
      me.loading = true;
      getAdunits({
        reportType: me.reportTypeInput,
        publisherId: me.selectedPublisherId as number,
        index: me.pageIndex as number,
        name: me.searchName as string,
      })
        .then((res: AxiosResponse<PublishersAdunitResponse>) => {
          me.adunitList = res.data.adunits;
          me.filterSize = res.data.total;
        })
        .catch(error => {
          if (error.response.status === 401) {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
            this.$router.push({ name: "Login" });
          } else notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.adUnits"));
        })
        .finally(() => {
          me.loading = false;
        });
    },
    getAdunitGroups() {
      const me = this as any;
      me.loading = true;
      reportApi
        .getAdunitGroup({
          publisherId: me.selectedPublisherId as number,
          page: me.pageIndex as number,
          name: me.searchName as string,
        })
        .then((res: AxiosResponse<GetAdunitGroupsResponse>) => {
          me.adunitGroupList = res.data.adunitGroups;
          me.filterSize = res.data.total;
        })
        .catch(error => {
          if (error.response.status === 401) {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
            this.$router.push({ name: "Login" });
          } else
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.adUnitGroups"));
        })
        .finally(() => {
          me.loading = false;
        });
    },
    getDomains() {
      const me = this as any;
      me.loading = true;
      reportApi
        .getDomains(me.reportTypeInput, {
          publisherId: me.selectedPublisherId as number,
          page: me.pageIndex as number,
          name: me.searchName as string,
        })
        .then((res: AxiosResponse<GetDomainsResponse>) => {
          me.domainList = res.data.domains;
          me.filterSize = res.data.total;
        })
        .catch(error => {
          if (error.response.status === 401) {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
            this.$router.push({ name: "Login" });
          } else notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.domains"));
        })
        .finally(() => {
          me.loading = false;
        });
    },
    async filteringPublishers() {
      const me = this as any;
      const pagesize = 100;
      let tmpfilterSize = 0 as number;
      me.loading = true;

      // TODO: pc同様、選択済みの広告枠がうまく同期できない箇所の調査と v-checkbox の value を input-value に修正
      // NOTE: pc同様、パブリッシャーリストを再描画させることで一時的にバグ解消
      await asyncSleep(1);

      if (me.searchName) {
        const reg = new RegExp(me.searchName, "i");
        me.selectionPublisherList = me.publisherList.filter((publisher: Publisher) =>
          publisher.publisherName.match(reg)
        );
        tmpfilterSize = me.selectionPublisherList.length;
        me.selectionPublisherList = me.selectionPublisherList.slice(
          (me.pageIndex - 1) * pagesize,
          pagesize * me.pageIndex
        );
      } else {
        tmpfilterSize = me.publisherList.length;
        me.selectionPublisherList = me.publisherList.slice(
          (me.pageIndex - 1) * pagesize,
          pagesize * me.pageIndex
        );
      }
      if (me.activeFilter === FilterEnum.PUBLISHER.value) {
        me.filterSize = tmpfilterSize;
      }
      me.loading = false;
    },
    clearBiddersInput(this: any) {
      (this as any).$emit("clear", FilterEnum.BIDDER.value);
    },
    clearAdunitsInput(this: any) {
      (this as any).$emit("clear", FilterEnum.ADUNIT.value);
    },
    clearAdunitGroupsInput(this: any) {
      (this as any).$emit("clear", FilterEnum.ADUNIT_GROUP.value);
    },
    clearDevicesInput(this: any) {
      (this as any).$emit("clear", FilterEnum.DEVICE.value);
    },
    clearBrowsersInput(this: any) {
      (this as any).$emit("clear", FilterEnum.BROWSER.value);
    },
    clearOsInput(this: any) {
      (this as any).$emit("clear", FilterEnum.OS.value);
    },
    clearDomainsInput(this: any) {
      (this as any).$emit("clear", FilterEnum.DOMAIN.value);
    },
    clearPublishersInput(this: any) {
      (this as any).$emit("clear", FilterEnum.PUBLISHER.value);
    },
    clearAllFilters() {
      const me = this as any;
      me.$emit("clearAll");
      me.childBiddersInput.splice(0);
      me.childAdunitsInput.splice(0);
      me.childAdunitGroupsInput.splice(0);
      me.childDevicesInput.splice(0);
      me.childBrowsersInput.splice(0);
      me.childOsInput.splice(0);
      me.childDomainsInput.splice(0);
      me.childPublishersInput.splice(0);
    },
  },

  watch: {
    activeFilter() {
      const me = this as any;
      me.searchName = "";
      me.selectedPublisherId = 0;
      me.pageIndex = 1;
      me.filterSize = 0;

      // NOTE: Publisher の場合は Publisher を選択しないため、Publisher を選択した時点でページング処理を行う
      if (me.isPublisherFilter && me.selectionPublisherList.length !== 0) {
        me.filteringPublishers();
      }
    },
    selectedPublisherId() {
      const me = this as any;
      if (!me.selectedPublisherId) return;
      me.pageIndex = 1;
      me.doSearch();
    },
    reportTypeInput() {
      const me = this as any;
      me.publisherList.splice(0);
      // パブリッシャー再取得
      if (me.isMobileDisplay) {
        me.getPublishers();
      }

      // 各種リセット
      me.selectionPublisherList.splice(0);
      me.bidderList.splice(0);
      me.adunitList.splice(0);
      me.adunitGroupList.splice(0);
      me.domainList.splice(0);
      me.childBiddersInput.splice(0);
      me.childAdunitsInput.splice(0);
      me.childAdunitGroupsInput.splice(0);
      me.childDevicesInput.splice(0);
      me.childBrowsersInput.splice(0);
      me.childOsInput.splice(0);
      me.childDomainsInput.splice(0);
      me.childPublishersInput.splice(0);
      me.activeFilter = 0;
      me.selectedPublisherId = 0;
      me.searchName = "";
      me.pageIndex = 1;
    },
  },
});
